import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import { useTranslate } from "src/locales";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
//BAGITMIS;454032;07042025;
function WoundAssessCreate() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {}, []);

  const handleSaveMedcard = async () => {
    try {
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const handleAddMedcard = async () => {
    try {
      const response = "Medcard Eklendi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard Eklenirken hata oluştu!", "error");
    }
  };
//CKAPISIZ;456269;18042025; MEDCARD GUNCELLENDI
  const { t } = useTranslate();
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton onClick={handleSaveMedcard}></ByzNurseSaveButton>
        <ByzMuiAddButton onClick={handleAddMedcard}></ByzMuiAddButton>
        <ByzNurseDeleteButton
          onClick={handleDeleteMedcard}
        ></ByzNurseDeleteButton>
        <ByzNursePrintButton2></ByzNursePrintButton2>
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={9} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("wound-assess.title")}
              </ByzMuiTypography>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>{t("datetime")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "350px" }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>{t("createdby")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "350px" }}
                  disabled
                  label={t("createdby")}
                />
              </Grid>
            </Grid>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("wound-assess.wound")}
              </ByzMuiTypography>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.before-admission")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                >
                  <ByzMuiCheckBox color="info" />
                </Box>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>{t("wound-assess.type")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{ width: "100%", maxWidth: "350px" }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                container
                direction={"row"}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 6 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.event-time-year")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>{t("months")}</ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>{t("day")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px", display: "flex" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "110px" }}
                  placeholder={t("enter")}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "110px", marginLeft: "10px" }}
                  placeholder={t("enter")}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "110px", marginLeft: "10px" }}
                  placeholder={t("enter")}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                container
                direction={"row"}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 6 }}
              >
                <ByzMuiTypography>{t("wound-assess.height")}</ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>
                  {t("wound-assess.width")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>
                  {t("wound-assess.depth")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>
                  {t("wound-assess.area")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px", display: "flex" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "85px" }}
                  placeholder={t("enter")}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "85px", marginLeft: "11px" }}
                  placeholder={t("enter")}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "85px", marginLeft: "11px" }}
                  placeholder={t("enter")}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "63px", marginLeft: "11px" }}
                  disabled
                  placeholder=""
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  pl: 5,
                }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.area-two")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField sx={{ width: "100%", maxWidth: "350px" }} />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.pressure-sore-area")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.pressure-sore-stage")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 6 }}
                container
                direction={"row"}
              >
                <ByzMuiTypography>
                  {t("wound-assess.tunnel-sinus-exists")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>
                  {t("wound-assess.its-depth")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <Stack flexDirection={"row"}>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "175px",
                      display: "flex",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                  <ByzMuiTextField sx={{ width: "100%", maxWidth: "175px" }} />
                </Stack>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.wound-bed")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.skin-around-the-wound")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.infection")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("wound-assess.characteristics-of-exudate")}
              </ByzMuiTypography>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>{t("wound-assess.amount")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>{t("type")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.color-smell")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("wound-assess.treatment-plan")}
              </ByzMuiTypography>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                container
                direction={"row"}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 6 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.primary-dressing")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>{t("other")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px", display: "flex" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "170px",
                  }}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "170px", marginLeft: "10px" }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                container
                direction={"row"}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 6 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.secondary-dressing")}
                </ByzMuiTypography>
                <ByzMuiTypography hasLeftBorder>{t("other")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px", display: "flex" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "170px",
                  }}
                />
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "170px", marginLeft: "10px" }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  pl: 5,
                }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.dressing-frequency")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "350px" }}
                  placeholder=""
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", pl: 5 }}
              >
                <ByzMuiTypography>
                  {t("wound-assess.intensity-of-wound-related-pain")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  placeholder={t("open-process-menu.select", "capitalize")}
                  sx={{
                    width: "100%",
                    maxWidth: "350px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  pl: 5,
                }}
              >
                <ByzMuiTypography>{t("note")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "350px" }}
                  placeholder={t("note")}
                />
              </Grid>
            </Grid>

            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default WoundAssessCreate;
